import { resolveApiUrl } from '@/config';
const OAUTH_REDIRECT_KEY = 'cs_wechat_oauth_ts';
export function isWeChatBrowser() {
    return /MicroMessenger/i.test(navigator.userAgent);
}
export function getOpenidFromQuery() {
    const params = new URLSearchParams(window.location.search);
    return params.get('openid');
}
/**
 * 微信 OAuth 必须用浏览器 GET 跳转（无法带 HEAD/BODY）。
 * 使用绝对地址，避免微信内相对路径异常。
 */
export function redirectWeChatOAuth(accessId) {
    const redirectUri = encodeURIComponent(window.location.href.split('#')[0] ?? window.location.origin);
    const url = `${resolveApiUrl('/kf/h5/wechat/oauth')}?accessId=${encodeURIComponent(accessId)}&redirectUri=${redirectUri}`;
    window.location.replace(url);
}
/** 防止微信 OAuth 失败时反复跳转导致 iOS 白屏/闪屏 */
export function shouldBlockWeChatOAuth() {
    try {
        const last = sessionStorage.getItem(OAUTH_REDIRECT_KEY);
        if (!last)
            return false;
        return Date.now() - Number(last) < 15000;
    }
    catch {
        return false;
    }
}
export function markWeChatOAuthRedirect() {
    try {
        sessionStorage.setItem(OAUTH_REDIRECT_KEY, String(Date.now()));
    }
    catch {
        // ignore private mode
    }
}
export function clearWeChatOAuthRedirect() {
    try {
        sessionStorage.removeItem(OAUTH_REDIRECT_KEY);
    }
    catch {
        // ignore
    }
}
